var _rect, _rect2, _ellipse, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 7,
    fill: "#11041E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 13.0001,
    y: 13.625,
    width: 22.75,
    height: 22.75,
    rx: 5.25,
    fill: "url(#paint0_linear_1433_12759)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8751,
    cy: 19.6875,
    rx: 6.125,
    ry: 5.6875,
    fill: "url(#paint1_linear_1433_12759)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5169 35.0748C10.416 35.2106 10.4443 35.4024 10.5801 35.5033C10.7158 35.6042 10.9077 35.5759 11.0085 35.4401L10.5169 35.0748ZM17.3011 26.4568L17.5457 26.2725L17.2994 25.9456L17.0553 26.2742L17.3011 26.4568ZM21.7694 32.3864L21.5248 32.5707L21.7436 32.861L21.9926 32.5961L21.7694 32.3864ZM34.2374 19.1175L30.8517 20.1385L33.4288 22.56L34.2374 19.1175ZM11.0085 35.4401L17.547 26.6395L17.0553 26.2742L10.5169 35.0748L11.0085 35.4401ZM17.0566 26.6411L21.5248 32.5707L22.014 32.2021L17.5457 26.2725L17.0566 26.6411ZM21.9926 32.5961L32.5732 21.3358L32.1268 20.9164L21.5462 32.1767L21.9926 32.5961Z",
    fill: "#B271F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_12759",
    x1: 24.3751,
    y1: 13.625,
    x2: 24.3751,
    y2: 36.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9340D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391864"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_12759",
    x1: 33.8751,
    y1: 14,
    x2: 33.8751,
    y2: 25.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9340D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391864"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenuIcon);
export default __webpack_public_path__ + "static/media/dashboardMenuIcon.981dee2e6283877ae9fa6d4ecb4fb79b.svg";
export { ForwardRef as ReactComponent };